import axios from "../../axios";

const getVendorById = async (vendor_id) => {
  try {
    const { data } = await axios.get(`/vendors/${vendor_id}`);
    return data;
  } catch (e) {
    throw e;
  }
}

const getWholesaleVendors = async () => {
  try {
    const { data } = await axios.get(`/vendors?wholesale_vendor[$eq]=true`);
    return data?.rows;
  } catch (e) {
    return null;
  }
};

const getRepairVendors = async () => {
  try {
    const { data } = await axios.get(`/vendors?does_repairs[$eq]=true`);
    return data?.rows;
  } catch (e) {
    return null;
  }
};


export { getRepairVendors, getWholesaleVendors, getVendorById };